export const RADIO_PALETTES = [
  {
    id: 'midnight-navy',
    label: 'Midnight Navy',
    vars: {
      '--radio-primary': '#0c203f',
      '--radio-secondary': '#152f51',
      '--radio-tertiary': '#1f2a46',
      '--radio-accent': '#5c9acb',
      '--radio-deep': '#040c1b',
      '--radio-bg': '#030711',
      '--radio-bg-surface': '#0b1224',
      '--radio-text': '#eff4ff',
      '--radio-text-secondary': '#aabed2',
      '--radio-playing-color': '#eff4ff',
      '--radio-border': 'rgba(108, 144, 186, 0.32)',
      '--radio-shadow': 'rgba(2, 8, 22, 0.9)',
      '--radio-shadow-light': 'rgba(255, 255, 255, 0.12)'
    }
  },
  {
    id: 'sage',
    label: 'Sage',
    vars: {
      '--radio-primary': '#c2d9b8',
      '--radio-secondary': '#b6c9b8',
      '--radio-tertiary': '#9cb1b1',
      '--radio-accent': '#8e9cab',
      '--radio-deep': '#7a8097',
      '--radio-bg': '#e7ece8',
      '--radio-bg-surface': '#dde4de',
      '--radio-text': '#2f3739',
      '--radio-text-secondary': '#5e6a70',
      '--radio-playing-color': '#2f3739',
      '--radio-playing-shadow': 'rgba(255, 255, 255, 0.45)',
      '--radio-border': 'rgba(156, 177, 177, 0.34)',
      '--radio-shadow': 'rgba(0, 0, 0, 0.1)',
      '--radio-shadow-light': 'rgba(255, 255, 255, 0.34)'
    }
  },
  {
    id: 'flexible-auto',
    label: 'Prismatic',
    vars: {
      '--radio-primary': '#7f95b0',
      '--radio-secondary': '#6c7f98',
      '--radio-tertiary': '#4d6078',
      '--radio-accent': '#9ec0db',
      '--radio-deep': '#253244',
      '--radio-bg': '#1f2c3d',
      '--radio-bg-surface': '#2a3b50',
      '--radio-text': '#eef4ff',
      '--radio-text-secondary': '#b8c8dc',
      '--radio-playing-color': '#eef4ff',
      '--radio-border': 'rgba(158, 192, 219, 0.3)',
      '--radio-shadow': 'rgba(6, 12, 22, 0.64)',
      '--radio-shadow-light': 'rgba(255, 255, 255, 0.1)',
      '--radio-memory-box-bg': `
        linear-gradient(180deg, #2f425a 0%, #233345 100%)
      `,
      '--radio-memory-box-overlay': `
        repeating-linear-gradient(
          -12deg,
          rgba(255, 255, 255, 0.03) 0 2px,
          rgba(0, 0, 0, 0.08) 2px 6px
        )
      `,
      '--radio-device-screen-bg': `
        linear-gradient(180deg, #2f425a 0%, #233345 100%)
      `,
    },
    swatch: `
      radial-gradient(circle at 50% 50%, #ffffff 0 22%, transparent 22%),
      conic-gradient(
        from -90deg at 50% 50%,
        #ff3b30 0deg 120deg,
        #32d74b 120deg 240deg,
        #0a84ff 240deg 360deg
      )
    `
  },
  {
    id: 'charcoal-black',
    label: 'Charcoal Black',
    vars: {
      '--radio-primary': '#2a2f37',
      '--radio-secondary': '#171b22',
      '--radio-tertiary': '#0e1218',
      '--radio-accent': '#a2a9b2',
      '--radio-deep': '#07090d',
      '--radio-bg': '#090c12',
      '--radio-bg-surface': '#141922',
      '--radio-text': '#e5eaf0',
      '--radio-text-secondary': '#a4afbd',
      '--radio-playing-color': '#f4f8ff',
      '--radio-border': 'rgba(162, 169, 178, 0.28)',
      '--radio-shadow': 'rgba(0, 0, 0, 0.68)',
      '--radio-shadow-light': 'rgba(225, 230, 236, 0.04)'
    },
    swatch: '#1d222b'
  },
  {
    id: 'mono-clean',
    label: 'Mono Clean',
    vars: {
      '--radio-primary': '#f2f2f2',
      '--radio-secondary': '#d9d9d9',
      '--radio-tertiary': '#b5b5b5',
      '--radio-accent': '#ffffff',
      '--radio-deep': '#111111',
      '--radio-bg': '#0a0a0a',
      '--radio-bg-surface': '#141414',
      '--radio-text': '#f5f5f5',
      '--radio-text-secondary': '#cecece',
      '--radio-playing-color': '#ffffff',
      '--radio-border': 'rgba(255, 255, 255, 0.28)',
      '--radio-shadow': 'rgba(0, 0, 0, 0.7)',
      '--radio-shadow-light': 'rgba(255, 255, 255, 0.1)'
    },
    swatch: 'linear-gradient(90deg, #000000 0 50%, #ffffff 50% 100%)'
  },
  {
    id: 'cyberpunk',
    label: 'Cyberpunk',
    vars: {
      '--radio-primary': '#7c3aed',
      '--radio-secondary': '#5a32c9',
      '--radio-tertiary': '#26093c',
      '--radio-accent': '#ff6ed8',
      '--radio-deep': '#120215',
      '--radio-bg': '#070215',
      '--radio-bg-surface': '#180a32',
      '--radio-text': '#f6f0ff',
      '--radio-text-secondary': '#d5c8f6',
      '--radio-playing-color': '#f8fcff',
      '--radio-border': 'rgba(255, 110, 216, 0.28)',
      '--radio-shadow': 'rgba(0, 0, 0, 0.5)',
      '--radio-shadow-light': 'rgba(124, 58, 237, 0.14)'
    },
    swatch: '#5a2a8c'
  },
  {
    id: 'nostalgic-wood',
    label: 'Nostalgic Wood',
    vars: {
      '--radio-primary': '#b67b45',
      '--radio-secondary': '#7f5230',
      '--radio-tertiary': '#5a351d',
      '--radio-accent': '#d9ab7a',
      '--radio-deep': '#2d170c',
      '--radio-bg': '#2a170f',
      '--radio-bg-surface': '#3a2417',
      '--radio-text': '#f3e0c9',
      '--radio-text-secondary': '#d6bb99',
      '--radio-playing-color': '#fff6e6',
      '--radio-border': 'rgba(217, 171, 122, 0.28)',
      '--radio-shadow': 'rgba(0, 0, 0, 0.36)',
      '--radio-shadow-light': 'rgba(255, 226, 187, 0.1)',
      '--radio-memory-box-bg': `
        radial-gradient(circle at 14% 20%, rgba(255, 222, 176, 0.12) 0%, transparent 38%),
        radial-gradient(circle at 82% 76%, rgba(52, 27, 13, 0.24) 0%, transparent 44%),
        url('/assets/wooden-tile.webp') center / 180% 100% no-repeat,
        linear-gradient(180deg, #6a4328 0%, #4a2f1c 100%)
      `,
      '--radio-memory-box-overlay': `
        repeating-linear-gradient(
          -8deg,
          rgba(255, 225, 184, 0.018) 0 2px,
          rgba(64, 36, 20, 0.03) 2px 6px
        )
      `,
      '--radio-device-screen-bg': `
        radial-gradient(circle at 14% 20%, rgba(255, 222, 176, 0.12) 0%, transparent 38%),
        radial-gradient(circle at 82% 76%, rgba(52, 27, 13, 0.24) 0%, transparent 44%),
        url('/assets/wooden-tile.webp') left center / 180% 100% no-repeat,
        url('/assets/wooden-tile.webp') right center / 180% 100% no-repeat,
        linear-gradient(180deg, #6a4328 0%, #4a2f1c 100%)
      `
    }
  },
//   {
//     id: 'rainy-gloom',
//     label: 'Rainy Gloom',
//     vars: {
//       '--radio-primary': '#556777',
//       '--radio-secondary': '#2f3e52',
//       '--radio-tertiary': '#1f2a38',
//       '--radio-accent': '#6e7c8e',
//       '--radio-deep': '#0f1620',
//       '--radio-bg': '#131d29',
//       '--radio-bg-surface': '#1a2634',
//       '--radio-text': '#dfe7ee',
//       '--radio-text-secondary': '#a7b4c1',
//       '--radio-border': 'rgba(110, 124, 142, 0.3)',
//       '--radio-shadow': 'rgba(0, 0, 0, 0.34)',
//       '--radio-shadow-light': 'rgba(255, 255, 255, 0.08)'
//     }
//   },
  {
    id: 'power-surge',
    label: 'Power Surge',
    vars: {
      '--radio-primary': '#b5001e',
      '--radio-secondary': '#8b0000',
      '--radio-tertiary': '#360003',
      '--radio-accent': '#ff1f3a',
      '--radio-deep': '#080103',
      '--radio-bg': '#070104',
      '--radio-bg-surface': '#120608',
      '--radio-text': '#ffe9ea',
      '--radio-text-secondary': '#ffe9ea',
      '--radio-playing-color': '#ffffff',
      '--radio-border': 'rgba(255, 31, 58, 0.3)',
      '--radio-shadow': 'rgba(0, 0, 0, 0.46)',
      '--radio-shadow-light': 'rgba(255, 255, 255, 0.08)'
    },
    swatch: '#b5001e'
  },
  {
    id: 'grand-prix',
    label: 'Grand Prix',
    vars: {
      '--radio-primary': '#d90f23',
      '--radio-secondary': '#161a20',
      '--radio-tertiary': '#2f3741',
      '--radio-accent': '#f3d447',
      '--radio-deep': '#050609',
      '--radio-bg': '#07090d',
      '--radio-bg-surface': '#111821',
      '--radio-text': '#f5f7fb',
      '--radio-text-secondary': '#b7c0cc',
      '--radio-playing-color': '#ffffff',
      '--radio-border': 'rgba(243, 212, 71, 0.42)',
      '--radio-shadow': 'rgba(0, 0, 0, 0.7)',
      '--radio-shadow-light': 'rgba(255, 255, 255, 0.08)',
      '--radio-memory-box-bg': `
        radial-gradient(circle at 16% 18%, rgba(217, 15, 35, 0.2) 0%, transparent 36%),
        radial-gradient(circle at 82% 78%, rgba(243, 212, 71, 0.13) 0%, transparent 34%),
        linear-gradient(180deg, #161d27 0%, #080a0f 100%)
      `,
      '--radio-memory-box-overlay': `
        repeating-linear-gradient(
          -18deg,
          rgba(255, 255, 255, 0.035) 0 2px,
          rgba(0, 0, 0, 0.12) 2px 6px
        )
      `
    },
    swatch: `
      linear-gradient(45deg, #ffffff 0 18%, #111111 18% 36%, #ffffff 36% 54%, #111111 54% 72%, #d90f23 72% 100%)
    `
  },
  {
    id: 'sky-blue',
    label: 'Sky Blue',
    vars: {
      '--radio-primary': '#ffd95a',
      '--radio-secondary': '#9ed8ff',
      '--radio-tertiary': '#67bdf5',
      '--radio-accent': '#ff9ac8',
      '--radio-deep': '#5f9fd6',
      '--radio-bg': '#ecf8ff',
      '--radio-bg-surface': '#dbf1ff',
      '--radio-text': '#2a5d86',
      '--radio-text-secondary': '#4a82ab',
      '--radio-playing-color': '#2a5d86',
      '--radio-playing-shadow': 'rgba(255, 255, 255, 0.45)',
      '--radio-border': 'rgba(103, 189, 245, 0.34)',
      '--radio-shadow': 'rgba(53, 102, 146, 0.16)',
      '--radio-shadow-light': 'rgba(255, 255, 255, 0.6)'
    },
    swatch: '#9ed8ff'
  },
  {
    id: 'snow-white',
    label: 'Snow White',
    vars: {
      '--radio-primary': '#c8dbef',
      '--radio-secondary': '#dcecff',
      '--radio-tertiary': '#b4cce3',
      '--radio-accent': '#f7fbff',
      '--radio-deep': '#7b97b2',
      '--radio-bg': '#d2e6fa',
      '--radio-bg-surface': '#e5f1fd',
      '--radio-text': '#1f3850',
      '--radio-text-secondary': '#4c6780',
      '--radio-playing-color': '#1f3850',
      '--radio-playing-shadow': 'rgba(255, 255, 255, 0.4)',
      '--radio-border': 'rgba(123, 151, 178, 0.32)',
      '--radio-shadow': 'rgba(80, 108, 136, 0.18)',
      '--radio-shadow-light': 'rgba(255, 255, 255, 0.75)',
      '--radio-memory-box-bg': `
        radial-gradient(circle at 18% 14%, rgba(255, 255, 255, 0.55) 0%, transparent 34%),
        radial-gradient(circle at 80% 76%, rgba(188, 220, 248, 0.5) 0%, transparent 38%),
        linear-gradient(180deg, #eef7ff 0%, #dbeeff 100%)
      `,
      '--radio-memory-box-overlay': `
        repeating-linear-gradient(
          -16deg,
          rgba(255, 255, 255, 0.1) 0 2px,
          rgba(186, 210, 233, 0.12) 2px 5px
        )
      `
    },
    swatch: '#edf6ff'
  },
  {
    id: 'ash-gray',
    label: 'Ash Gray',
    vars: {
      '--radio-primary': '#6a6f78',
      '--radio-secondary': '#4d525a',
      '--radio-tertiary': '#3a3f46',
      '--radio-accent': '#9aa1ab',
      '--radio-deep': '#1a1c20',
      '--radio-bg': '#1f2125',
      '--radio-bg-surface': '#2a2d33',
      '--radio-text': '#d8dbe0',
      '--radio-text-secondary': '#a1a8b2',
      '--radio-playing-color': '#f1f4f8',
      '--radio-border': 'rgba(154, 161, 171, 0.28)',
      '--radio-shadow': 'rgba(5, 6, 8, 0.62)',
      '--radio-shadow-light': 'rgba(255, 255, 255, 0.06)',
      '--radio-memory-box-bg': `
        radial-gradient(circle at 14% 24%, rgba(205, 211, 220, 0.08) 0%, transparent 34%),
        radial-gradient(circle at 78% 76%, rgba(96, 102, 113, 0.18) 0%, transparent 40%),
        linear-gradient(180deg, #2d3036 0%, #1e2024 100%)
      `,
      '--radio-memory-box-overlay': `
        repeating-linear-gradient(
          -14deg,
          rgba(194, 199, 207, 0.03) 0 2px,
          rgba(22, 24, 30, 0.08) 2px 6px
        )
      `
    },
    swatch: '#4c5159'
  },
  {
    id: 'cupid-pink',
    label: 'Cupid Pink',
    vars: {
      '--radio-primary': '#ea6aa7',
      '--radio-secondary': '#ff92c7',
      '--radio-tertiary': '#ff7fb5',
      '--radio-accent': '#ff79c2',
      '--radio-deep': '#b2135d',
      '--radio-bg': '#fef0f6',
      '--radio-bg-surface': '#fde8f3',
      '--radio-text': '#2b0c22',
      '--radio-text-secondary': '#5d2551',
      '--radio-playing-color': '#2b0c22',
      '--radio-playing-shadow': 'rgba(255, 255, 255, 0.42)',
      '--radio-border': 'rgba(255, 148, 203, 0.75)',
      '--radio-shadow': 'rgba(182, 69, 129, 0.25)',
      '--radio-shadow-light': 'rgba(255, 255, 255, 0.75)'
    }
  },
  {
    id: 'sunset-flare',
    label: 'Sunset Flare',
    vars: {
      '--radio-primary': '#ef6047',
      '--radio-secondary': '#ff8b3d',
      '--radio-tertiary': '#ffb13b',
      '--radio-accent': '#ffd25e',
      '--radio-deep': '#8e3a20',
      '--radio-bg': '#5a1d16',
      '--radio-bg-surface': '#7a2c1a',
      '--radio-text': '#fff0d7',
      '--radio-text-secondary': '#ffcfa0',
      '--radio-playing-color': '#fff0d7',
      '--radio-border': 'rgba(255, 154, 61, 0.38)',
      '--radio-shadow': 'rgba(36, 10, 3, 0.5)',
      '--radio-shadow-light': 'rgba(255, 208, 116, 0.14)',
      '--radio-memory-box-bg': `
        radial-gradient(circle at 14% 18%, rgba(255, 219, 109, 0.32) 0%, transparent 36%),
        radial-gradient(circle at 80% 74%, rgba(255, 114, 72, 0.28) 0%, transparent 42%),
        linear-gradient(180deg, #a63822 0%, #641f16 54%, #4b1a14 100%)
      `,
      '--radio-memory-box-overlay': `
        repeating-linear-gradient(
          -12deg,
          rgba(255, 200, 112, 0.05) 0 2px,
          rgba(159, 67, 28, 0.06) 2px 5px
        )
      `
    },
    swatch: '#ef6047'
  },
  {
    id: 'forest-green',
    label: 'Forest Green',
    vars: {
      '--radio-primary': '#375643',
      '--radio-secondary': '#4a6c55',
      '--radio-tertiary': '#2a3f2f',
      '--radio-accent': '#86a583',
      '--radio-deep': '#0c1710',
      '--radio-bg': '#0f1c16',
      '--radio-bg-surface': '#152819',
      '--radio-text': '#e6f0e8',
      '--radio-text-secondary': '#9db8a9',
      '--radio-playing-color': '#ffffff',
      '--radio-border': 'rgba(135, 170, 143, 0.35)',
      '--radio-shadow': 'rgba(2, 6, 4, 0.9)',
      '--radio-shadow-light': 'rgba(202, 229, 201, 0.08)'
    }
  }
];

export const DEFAULT_RADIO_PALETTE_ID = RADIO_PALETTES[0].id;

export function findPaletteById(id) {
  return RADIO_PALETTES.find((palette) => palette.id === id) || RADIO_PALETTES[0];
}

export function applyRadioPalette(id) {
  const palette = findPaletteById(id);
  Object.entries(palette.vars).forEach(([name, value]) => {
    document.documentElement.style.setProperty(name, value);
  });
  return palette.id;
}
